import { Component, input } from '@angular/core';
import { helpCenterUrl } from '../../../../_fixtures/project-fixtures';
import { NgClass, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-no-cards-available-display',
  imports: [NgOptimizedImage, NgClass],
  template: `<div
    class="text-center"
    [ngClass]="displaySmaller() ? 'my-1' : 'my-3'">
    @if (displaySmaller()) {
      <img
        ngSrc="./assets/graphic-no-cards.svg"
        width="120"
        height="112"
        alt="No cards available"
        class="img-fluid" />
    } @else {
      <img
        ngSrc="./assets/graphic-no-cards.svg"
        width="174"
        height="162"
        alt="No cards available"
        class="img-fluid" />
    }
    <p class="my-3">You do not have any available cards to assign to employees.</p>

    <a
      [href]="helpCenterUrl"
      id="contactSupportBtn"
      target="_blank"
      rel="noopener"
      class="help-center-link">
      Contact Paystashio Support <i class="iconoir-arrow-up-right"></i>
    </a>
  </div> `,
})
export class NoCardsAvailableDisplayComponent {
  displaySmaller = input<boolean>(false);
  protected readonly helpCenterUrl = helpCenterUrl;
}
